<app-tile-list [tiles]="pathTiles" (tileClicked)="tileClicked.emit($event)"></app-tile-list>
